import React, { Component } from "react";
import { HashRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import Routes from "./Routes";

import './App.css'

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <Routes/>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js